export default function getExportingJob(jobId?: string): string {
  return jobId ? `/exporting/jobs/${jobId}` : `/exporting/jobs/`;
}
